import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Path from '@leverege/path'
import PatchOps from '@leverege/api-patch-ops'
import ObjectUtil from '@leverege/object-util'
import { Flex, Button, Content, Dialog as LevDialog } from '@leverege/ui-elements'

import { Dialog } from 'react-bootstrap/lib/Modal'
import { camelCaseToTitleCase, capitalize } from '@leverege/string-util'
import { TemplateActions, BreadcrumbActions } from '../../actions'
import { TemplateFactory } from '../../editors/template'

import S from './TemplatesScreen.css'

class TemplateDataScreen extends React.Component {

  constructor( props ) {
    super( props )
    this.state = {
      draftIntent : null,
      templateData : ''
    }
  }

  componentWillReceiveProps( next ) {
    const { templates, intent } = next
    const { params } = next.match
    const templateId = params.templateId
    const template = templates.lookup[templateId]

    const templateData = Path( `templates/lookup/${templateId}/intents/${intent}/data` ).get( next, '' )
    this.setState( { templateData } )

    if ( template ) {
      this.props.dispatch( BreadcrumbActions.setBreadcrumbs( 
        [
          { name : 'Templates', link : `/project/${template.projectId}/template` }, 
          { name : template.name }
        ]
      ) )
    }
  
  }

  onSave = () => {

  }
  
  getProjectId() {
    return this.props.match.params.projectId
  }

  getTemplateId() {
    return this.props.match.params.templateId
  }

  getIntent( ) {
    const { templates, intentType = 'email' } = this.props
    const templateId = this.getTemplateId()
    if ( templates == null || templateId == null || intentType == null ) {
      return null
    }

    const template = templates.lookup[templateId]
    const intent = template && template.intents && template.intents[intentType]
    return intent || null
  }

  onChange = ( event ) => {
    const { value } = event
    console.log( 'got intent change', value )
    this.setState( { draftIntent : value } )
  }

  onSave = ( ) => {
    const projectId = this.getProjectId()
    const templateId = this.getTemplateId()
    const { draftIntent } = this.state
    const { intentType } = this.props

    if ( draftIntent != null ) {
      const patchOps = PatchOps().replace( `intents/${intentType}`, draftIntent ).ops()
      this.props.dispatch( TemplateActions.update( projectId, templateId, patchOps ) )
    }
  }

  onRevert = ( ) => {
    const intent = this.getIntent()
    if ( intent ) {
      this.setState( { draftIntent : ObjectUtil.copy( intent ) } )
    }
  }

  onDelete = () => {
    const { dispatch, intentType } = this.props

    const projectId = this.getProjectId()
    const templateId = this.getTemplateId()

    if ( projectId && templateId && intentType ) {
      const patchOps = PatchOps().remove( `intents/${intentType}` ).ops()
      dispatch( TemplateActions.update( projectId, templateId, patchOps ) )
    }
  }

  onConfirmDelete = async () => {
    const { intentType } = this.props

    const intentFormatted = camelCaseToTitleCase( intentType )
    const res = await LevDialog.Question.ask( {
      title : `Delete ${intentFormatted} intent?`,
      message : `Are you sure you want to delete the ${intentFormatted} intent?`,
      okay : 'Delete',
      okayVariant : 'primaryDestructive'
    } )

    if ( res ) {
      this.onDelete()
    }
  }

  render() {
    const { intentType = 'email', showSubject = false } = this.props
    const intent = this.getIntent()

    const details = TemplateFactory.createDataEditor( intentType, {
      intent : this.state.draftIntent || intent,
      onChange : this.onChange,
      enableSave : true,
      showSubject
    } )
    return (
      <Content className={S.content}>
        <Content.Header className={S.contentHeader}>
          <Flex variant="rowL" justify="flex-end" align="center">
            <Button variant="linkDestructive" onClick={this.onConfirmDelete}>Delete</Button>
            <Button onClick={this.onRevert}>Revert</Button>
            <Button onClick={this.onSave}>Save</Button>
          </Flex>
        </Content.Header>
        <Content.Area>
          <div className={S.editor}>
            {details}
          </div>
        </Content.Area>
      </Content>
    )
  }
}

export default connect(
  state => ( {
    templates : state.templates,
  } )
)( TemplateDataScreen )
